<div class="container">

<div class="row">
<div class="col-md-12">
  <h3 class="">Our Privacy Policy</h3>
  <ul class="" style="list-style-type: number;">
    <li style="padding: 5px 5px;">Paymentor.io is a product of Paymentor.io copyrighted &copy;2021</li>
    <li style="padding: 5px 5px;">Paymentor.io is not any way affiliated with any of the Payment Service Providers and platforms listed on this site. However,
    paymentor.io is a huge repository of payment service providers and platforms</li>
    <li style="padding: 5px 5px;">The only user data collected is email for newsletter subscription and it is based on the NDPR data use consent</li>
    <li style="padding: 5px 5px;"><i>No User Data is collected</i> on this website without the direct consent of the user. It means we do not capture nor use any user data
    such as browser information, ip addresses, etc</li>


  </ul>
</div>
</div>

</div>
